import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
    Box,
    Grid,
    Card,
    CardActionArea,
    CardActions,
    CardContent,
    CardMedia,
    Button,
    Typography,
} from "@material-ui/core";

import mvc from '../images/mvc.png'
import springboot1 from '../images/spring-boot-1.png'

const useStyles = makeStyles({
    '@global': {
        // You should target [class*="MuiButton-root"] instead if you nest themes.
        '.MuiCard-root': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
        },
    },
    mainContainer: {
        background: "#233",
        minHeight: "45vw",
    },
    cardContainer: {
        maxWidth: 345,
        minHeight: 425,
        margin: "2rem auto",
    },
});

const Blogs = () => {
    const classes = useStyles();

    return (
        <Box component="div" className={classes.mainContainer}>
            <Grid container justify="center">
                {/* Blog 1 */}
                <Grid item xs={12} sm={8} md={6} lg={4}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="MVC Architecture"
                                height="140"
                                image={mvc}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    MVC Architecture
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    over the last 30 years websites have gone from simple HTML pages with a bit
                                    of CSS to incredibly complex application with thousands of developers working
                                    on them. To decrease the complexity of project, developers started to use
                                    different software Architectural design patterns
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                        <CardActions>
                            <a href='https://mhdrazan7.medium.com/mvc-architecture-14238e8b93bc'>
                                <Button size="small" color="primary">
                                    Read More
                                </Button>
                            </a>
                        </CardActions>
                    </Card>
                </Grid>
                {/* Blog 2 */}
                <Grid item xs={12} sm={8} md={6} lg={4}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Spring boot"
                                height="140"
                                image={springboot1}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    Spring boot Series-1 project setup and CRUD operations
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    In this spring boot series, I am going to show you all how to develop
                                    a spring boot project from basic. In this article we’ll focus on how to
                                    start a spring boot project and do all the four CRUD (Create, Read, Update and Delete)
                                    operations using a single table
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                        <CardActions>
                            <a href='https://mhdrazan7.medium.com/spring-boot-series-1-project-setup-and-crud-operations-eb297d39ba22'>
                                <Button size="small" color="primary">
                                    Read More
                                </Button>
                            </a>
                        </CardActions>
                    </Card>
                </Grid>
                {/* Blog 3 */}
                <Grid item xs={12} sm={8} md={6} lg={4}>
                    <Card className={classes.cardContainer}>
                        <CardActionArea>
                            <CardMedia
                                component="img"
                                alt="Spring boot"
                                height="140"
                                image={springboot1}
                            />
                            <CardContent>
                                <Typography gutterBottom variant="h5">
                                    Spring boot Series-2 One to One and One to Many mapping
                                </Typography>
                                <Typography variant="body2" color="textSecondary" component="p">
                                    In this article I’ll show you how to implement one to one 
                                    and one to many mapping using hibernate in Spring boot.
                                </Typography>
                            </CardContent>
                        </CardActionArea>
                        <CardActions>
                            <a href='https://link.medium.com/n0W5CUR3bhb'>
                                <Button size="small" color="primary">
                                    Read More
                                </Button>
                            </a>
                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    );
};

export default Blogs;
